import { Avatar, AvatarFallback } from '@e2n/ui';
import { Termin } from '@/domain/arbeitszeiten/entities/Termin';
import { markierungMapper } from '@/utils';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { CSSProperties } from 'react';

type StyleProps = CSSProperties & {
  '--border-color': CSSProperties['color'];
};

export function TerminItem({ termin }: { termin: Termin }) {
  return (
    <div className="flex gap-2 items-center">
      <Avatar
        className="w-8 h-8 border-2 border-[--border-color] "
        style={
          {
            '--border-color': termin.markierung
              ? markierungMapper[termin.markierung].base
              : '',
          } as StyleProps
        }>
        <AvatarFallback>
          <FontAwesomeIcon icon={faCalendar} />
        </AvatarFallback>
      </Avatar>
      <div className="flex-col flex font-normal">
        <div className="text-sm">{termin.titel}</div>
        {termin.beginn && termin.ende && (
          <div className="text-xs text-neutrals-800">
            {`${dayjs(termin.beginn).format('HH:mm')} – ${dayjs(
              termin.ende,
            ).format('HH:mm')}`}
          </div>
        )}
      </div>
    </div>
  );
}
